function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "442D3AF8-B4BC-45C7-9173-2525332721DF");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "tablet",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Dashboard---expanded",
  className: "x-path-to-fill",
  transform: "translate(-277.000000, -26.000000)",
  fill: "#172B4D"
}, React.createElement("g", {
  id: "top-bar",
  transform: "translate(241.000000, -0.000000)"
}, React.createElement("g", {
  id: "menu-icon",
  transform: "translate(35.000000, 26.000000)"
}, React.createElement("g", {
  id: "Group-10"
}, React.createElement("rect", {
  id: "Rectangle-19",
  transform: "translate(11.000000, 10.500000) rotate(-45.000000) translate(-11.000000, -10.500000) ",
  x: -2,
  y: 9,
  width: 26,
  height: 3,
  rx: 1.5
}), React.createElement("rect", {
  id: "Rectangle-19-Copy",
  transform: "translate(11.000000, 10.500000) rotate(45.000000) translate(-11.000000, -10.500000) ",
  x: -2,
  y: 9,
  width: 26,
  height: 3,
  rx: 1.5
}))))));

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.43e73f3d.svg";
export { ForwardRef as ReactComponent };